<template>
  <div class="modal-bank">
    <b-modal
      modal-class="charity-modal"
      id="modal-bank"
      ref="modal-bank"
      centered
      no-fade
      hide-footer
      hide-header
    >
      <div class="modal-header">
        <div class="modal-logo">
          <img class="logo" src="img/brand/login-logo.png" alt="logo" />
          <h4 class="title">{{$t('Bank_Details')}}</h4>
        </div>
      </div>
      <div class="modal-body">
        <div class="bank-box">
          <div class="bank-title">{{$t('Bank_Name')}}</div>
          <div
            class="bank-info"
          >{{this.bankListData && this.bankListData.bank ? this.bankListData.bank.name : "no data"}}</div>
        </div>
        <div class="bank-box">
          <div class="bank-title">{{$t('Beneficiary_Name')}}</div>
          <div
            class="bank-info"
          >{{this.bankListData && this.bankListData.bank ? this.bankListData.bank.beneficiary_name : "no data"}}</div>
        </div>
        <div class="bank-box">
          <div class="bank-title">{{$t('BeneficiaryIBAN')}}</div>
          <div
            class="bank-info"
          >{{this.bankListData && this.bankListData.bank ? this.bankListData.bank.iban :"no data"}}</div>
        </div>
        <div class="bank-box">
          <div class="bank-title">{{$t('Swift_BIC_Code')}}</div>
          <div
            class="bank-info"
          >{{this.bankListData && this.bankListData.bank ? this.bankListData.bank.swift : 'no data'}}</div>
        </div>
        <div
          class="bank-box"
          v-if="this.bankListData.organization_name && this.bankListData.campaign_name == '' "
        >
          <div class="bank-title">{{$t('Organisation_Name')}}</div>
          <div
            class="bank-info"
          >{{this.bankListData && this.bankListData.organization_name ? this.bankListData.organization_name : "no data"}}</div>
        </div>

        <div
          class="bank-box"
          v-if="this.bankListData.campaign_name && this.bankListData.organization_name"
        >
          <div class="bank-title">{{$t('Project_name')}}</div>
          <div
            class="bank-info"
          >{{this.bankListData && this.bankListData.campaign_name ? this.bankListData.campaign_name : "no data"}}</div>
        </div>

        <div class="bank-box">
          <div class="bank-title">{{$t('Payment_Ref')}}</div>
          <div
            class="bank-info"
          >{{this.bankListData ? this.bankListData.transaction_reference : "no data"}}</div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="left-btn">
          <base-button type="default" @click="hideModal">{{$t('Back')}}</base-button>
        </div>
        <div class="right-btn">
          <base-button
            v-b-modal.modal-thankYou
            @click="updateTransactionByCampaign"
            type="success"
          >{{$t('Submit')}}</base-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-userInfo"
      ref="modal-userInfo"
      modal-class="charity-modal"
      centered
      no-fade
      hide-footer
      hide-header
    >
      <div class="modal-header">
        <div class="modal-logo">
          <img class="logo" src="img/brand/login-logo.png" alt="logo" />
          <h4 class="title">{{$t('User_Information')}}</h4>
        </div>
      </div>
      <div class="modal-body">
        <div class="donator-from">
          <b-input-group>
            <b-form-input :placeholder="$t('Your_Name')" v-model="modalData.payee_name"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-form-input
              :placeholder="$t('Donation_Amount')"
              v-model="modalData.amount"
              type="number"
            ></b-form-input>
          </b-input-group>
          <!-- <b-input-group>
              <b-form-input :placeholder="$t('Payment_Ref')" v-model="modalData.bank_reference"></b-form-input>
          </b-input-group>-->
          <b-input-group>
            <b-form-input :placeholder="$t('Email_Id')" v-model="modalData.payee_email"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-form-radio-group label="User Type">
              <b-form-checkbox
                id="checkbox-1"
                name="checkbox-1"
                v-model="modalData.is_anonymous"
              >{{$t('Make_anonymous')}}</b-form-checkbox>

              <!-- <b-form-radio name="some-radios" value="A">Make my donation anonymous</b-form-radio>
              <b-form-radio name="some-radios" value="B">Make my donation Named</b-form-radio>-->
            </b-form-radio-group>
          </b-input-group>
        </div>
      </div>
      <div class="modal-footer">
        <div class="left-btn">
          <base-button type="default" @click="hideModal2">{{$t('Back')}}</base-button>
        </div>
        <div class="right-btn">
          <base-button
            :disabled="checkIfDataValid===true"
            @click="getModalData()"
            type="success"
          >{{$t('Next')}}</base-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-thankYou"
      ref="modal-thankYou"
      modal-class="charity-modal"
      centered
      no-fade
      hide-footer
      hide-header
    >
      <div class="modal-header">
        <div class="modal-logo">
          <img class="logo" src="img/brand/login-logo.png" alt="logo" />
          <h4 class="title">{{$t('Thank_You')}}</h4>
        </div>
      </div>
      <div class="modal-body">
        <div class="thank-section">
          <div class="thank-image">
            <img src="img/give.png" alt="logo" />
          </div>
          <div class="thank-info">
            <h4>{{$t('Thank_You_info_1')}}</h4>
            <p>{{$t('Thank_You_info_2')}}</p>
            <p>{{$t('Thank_You_info_3')}}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="left-btn">
          <base-button type="default" @click="hideModal3">{{$t('Back')}}</base-button>
        </div>
        <div class="right-btn">
          <base-button @click="hideModal4" type="success">{{$t('Finish')}}</base-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  watch: {
    cardData(val) {
      console.log("card data", this.cardData);
    },
    viewAllCardData(val) {
      console.log("all data view watch", val);
      this.pID = val.id;
    }
  },
  props: ["cardData", "viewAllCardData"],
  data() {
    return {
      modalData: {
        is_anonymous: false,
        payee_email: "",
        payee_name: "",
        payee_contact: "",
        public_token: null,
        amount: null
      },
      text: "",
      bankListData: {},
      pID: null,
      projectName: "",
      orgName: ""
    };
  },
  methods: {
    hideModal() {
      this.$refs["modal-bank"].hide();
    },
    hideModal2() {
      this.$refs["modal-userInfo"].hide();
    },
    hideModal3() {
      this.$refs["modal-thankYou"].hide();
    },
    hideModal4() {
      this.$refs["modal-thankYou"].hide();
      this.$refs["modal-userInfo"].hide();
      this.$refs["modal-bank"].hide();
      this.modalData = {
        is_anonymous: false,
        payee_email: "",
        payee_name: "",
        payee_contact: "",
        public_token: null,
        amount: null
      };
    },
    getModalData() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
      if (!re.test(this.modalData.payee_email)) {
        this.$bvToast.toast("Please enter valid email id.");
        return;
      } else {
        this.$refs["modal-bank"].show();
      }

      this.transactionByCampaign();
      this.modalData = this.modalData;

      console.log("get modal data called", this.modalData);
      console.log("View_Alll card data", this.viewAllCardData);
    },

    transactionByCampaign() {
      // if( this.modalData.amount == '' && this.modalData.payee_contact == '' && this.modalData.payee_email =='' &&  this.modalData.payee_name==''  ){
      // //  this.$toasted.show("fill all details");
      //     this.$bvToast.toast("fill all data");
      //  return;
      // }

      if (this.cardData) {
        var urlWithService =
          process.env.VUE_APP_API_URL +
          `/transactions/campaign/init/${this.cardData.id}`;
      }
      if (!this.cardData) {
        var urlWithService =
          process.env.VUE_APP_API_URL +
          `/transactions/organization/init/default`;
      }
      if (
        this.$route.query.p == "COMPLETED" ||
        this.$route.query.p == "IN-QUEUE" ||
        this.$route.query.p == "RUNNING"
      ) {
        var urlWithService =
          process.env.VUE_APP_API_URL +
          `/transactions/campaign/init/${this.pID}`;
      }
      if (this.$route.query.q) {
        var urlWithService =
          process.env.VUE_APP_API_URL +
          `/transactions/campaign/init/${this.$route.query.q}`;
      }
      const token = localStorage.getItem("token");
      axios({
        method: "get",
        url: urlWithService,
        headers: { Authorization: ` ${token}` }
      })
        .then(Response => {
          if (Response) {
            this.bankListData = Response.data || {};
            this.modalData.public_token = this.bankListData.public_token;

            // if(this.bankListData.campaign_name){
            //     this.projectName = true;
            // }
            // if(this.bankListData.organization_name){
            //     this.orgName = true;
            // }
          }
        })
        .catch(error => this.$toasted.show(error));
    },

    updateTransactionByCampaign() {
      var urlWithService =
        process.env.VUE_APP_API_URL + `/transactions/update-details`;
      const token = localStorage.getItem("token");
      axios({
        method: "post",
        url: urlWithService,
        headers: { Authorization: ` ${token}` },
        data: this.modalData
      })
        .then(Response => {
          if (Response) {
            // this.bankListData = Response.data || {}
            // this.modalData.public_token = this.bankListData.public_token;
            console.log("update transaction response is", Response);
          }
        })
        .catch(error => this.$toasted.show(error));
    },

    showModal() {}
  },
  mounted() {
    console.log("modal data is", this.modalData);
    console.log("card data from projects", this.cardData);
    console.log("route param", this.$route.query.p);
  },

  computed: {
    checkIfDataValid() {
      if (
        this.modalData.payee_name != "" ||
        this.modalData.amount != null ||
        this.modalData.payee_email != ""
      ) {
        if (
          this.modalData.payee_name &&
          this.modalData.amount &&
          this.modalData.payee_email
        ) {
          return false;
        }
      } else if (this.modalData.is_anonymous == true) {
        return false;
      }
      return true;

      // if(this.modalData.is_anonymous == false){
      //   return true;
      // }return false;
    }
  }
};
</script>